import {
  Button,
  Flexbox,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import { SiteAvailabilityControl } from '@see-power-pft-common-js/net-availability/enums/site-availability-control';
import { Alert } from 'components/Alert/Alert';
import { SitesFetchingErrorState } from 'components/ErrorStates/NoSitesErrorState/SitesFetchingErrorState';
import { Page } from 'components/Layout/Page/Page';
import {
  CustomDivider,
  SectionHeader,
  SectionLeft,
  SectionRight,
} from 'components/Layout/SectionHeader/SectionHeader';
import { SiteSelector } from 'components/SiteSelector';
import { AssetLevelAvailability } from 'pages/Availability/AssetLevel/AssetLevelAvailability';
import DateRangeSelector from 'pages/Availability/common/DateRangeSelector/DateRangeSelector';
import { SiteLevelAvailability } from 'pages/Availability/SiteLevel/SiteLevelAvailability';
import { Site } from 'pages/Availability/types';
import { useStore } from 'store';

const DRAWER_WIDTH = '665px';

export const Availability = ({ sites }: { sites: Array<Site> }) => {
  const {
    selectedSiteData,
    availabilityFormOpen,
    setAvailabilityFormOpen,
    alertVisible,
  } = useStore((state) => ({
    selectedSiteData: state.selectedSiteData,
    availabilityFormOpen: state.availabilityFormOpen,
    setAvailabilityFormOpen: state.setAvailabilityFormOpen,
    alertVisible: state.alert.visible,
  }));

  const availabilityControl = selectedSiteData?.siteAvailabilityControl;
  const isAssetLevel =
    availabilityControl === SiteAvailabilityControl.AssetLevel;
  const isSiteLevel = availabilityControl === SiteAvailabilityControl.SiteLevel;

  const handleReportReductionClick = () => {
    setAvailabilityFormOpen(true);
  };

  if (!selectedSiteData) {
    return <SitesFetchingErrorState />;
  }

  return (
    <div>
      {alertVisible && <Alert />}
      <SectionHeader>
        <SectionLeft>
          <h1>Availability</h1>
          <SiteSelector
            sites={sites}
            showLimits={true}
            disabled={availabilityFormOpen}
            isAvailabilitySiteSelector
          />
          {!availabilityFormOpen && <DateRangeSelector />}
        </SectionLeft>
        <SectionRight>
          <Button
            data-testid="availability-report-a-reduction"
            style={{
              width: '200px',
              height: '75%',
            }}
            onClick={handleReportReductionClick}
          >
            Report a reduction
          </Button>
        </SectionRight>
      </SectionHeader>

      <CustomDivider size={Sizes.Small} prominence={'subtle'} />
      <Page>
        <Flexbox
          flexDirection={'row'}
          justifyContent={'space-between'}
          style={{
            minHeight: 'calc(100vh - 330px)',
          }}
        >
          {isAssetLevel && (
            <AssetLevelAvailability
              site={selectedSiteData}
              drawerWidth={DRAWER_WIDTH}
            />
          )}
          {isSiteLevel && (
            <SiteLevelAvailability
              site={selectedSiteData}
              drawerWidth={DRAWER_WIDTH}
            />
          )}
        </Flexbox>
      </Page>
    </div>
  );
};
